module.exports = __webpack_public_path__ + "img/logo-parte1.b671f704.png";